module.exports = __webpack_public_path__ + "static/media/flipkart.3024de32.png";